module.exports = __webpack_public_path__ + "src/assets/img/map-marker.50b2d159.svg";